import { schema } from "normalizr";

const AccountTypeSchema = new schema.Entity("accountTypes");

const AccountTypeArraySchema = new schema.Array(AccountTypeSchema);

export { AccountTypeSchema, AccountTypeArraySchema };